import axios from 'axios';
import {
    ICommissionSummaryRequest,
    ICommissionSummaryResponse,
} from 'components/CommissionListing/types';
import { getDD_MM_YYYY } from 'utils/date';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';

interface ICommissionAmountResponse {
    amount: number;
    status: boolean;
}
export const getCommissionAmount = async (
    partnerId
): Promise<ICommissionAmountResponse> => {
    const requestBody: ICommissionSummaryRequest = {
        from_date: getDD_MM_YYYY(new Date()),
        to_date: getDD_MM_YYYY(new Date()),
        page: 0,
        group_by: 'DATE',
    };
    try {
        const response = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/order/commission-summary`,
            ...getAxiosConfig(),
            data: requestBody,
        });

        const { data, status } = response;
        if (status === 200) {
            const commissionData = (data as ICommissionSummaryResponse).data;
            return {
                amount:
                    commissionData.length > 0
                        ? commissionData[0].commission_earned
                        : 0,
                status: true,
            } as ICommissionAmountResponse;
        }

        return {
            status: false,
        } as ICommissionAmountResponse;
    } catch (e: any) {
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        return {
            status: false,
        } as ICommissionAmountResponse;
    }
};
